import React, { useCallback } from "react";
import { ConfirmationModal } from "./confirmationModal";
import { useModalTools } from "./modalContext";

export function useConfirmation(
	title: string,
	confirmLabel: string,
	message?: string
): (action: () => Promise<void> | void) => void {
	const { createModal } = useModalTools();

	const askConfirmation = useCallback(
		(action: () => Promise<void> | void): void =>
			createModal((close) => (
				<ConfirmationModal
					close={async (confirm) => {
						if (confirm) {
							await action();
						}
						close();
					}}
					title={title}
					message={message}
					confirmLabel={confirmLabel}
				/>
			)),
		[title, confirmLabel]
	);

	return askConfirmation;
}
